import { getStatusIconStyles } from "~/areas/projects/components/Observability/LiveStatusIcons/GetStatusIconStyles";
export function InSyncIcon({ color }: {
    color?: string;
}) {
    const iconStyles = getStatusIconStyles(color || "#00874D");
    return (<svg className={iconStyles} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M35.8304 9.24049C36.7232 10.1332 36.7232 11.5831 35.8304 12.4758L17.5468 30.7595C16.654 31.6523 15.2042 31.6523 14.3114 30.7595L5.16957 21.6177C4.27681 20.7249 4.27681 19.2751 5.16957 18.3823C6.06233 17.4896 7.51216 17.4896 8.40492 18.3823L15.9327 25.9029L32.6022 9.24049C33.495 8.34773 34.9448 8.34773 35.8376 9.24049H35.8304Z"/>
        </svg>);
}
